/** The hideable data columns of the Add-wells table (the select checkbox is always shown), in order. */
export type AddWellsColumnKey = 'wellName' | 'uwi' | 'operator' | 'status';

export const ADD_WELLS_COLUMNS: { key: AddWellsColumnKey; label: string }[] = [
  { key: 'wellName', label: 'Well Name' },
  { key: 'uwi', label: 'UWI' },
  { key: 'operator', label: 'Operator' },
  { key: 'status', label: 'Well Status' },
];
